import { bindable } from 'aurelia';
import { Message } from './message';
export class CalloutGroup {
    @bindable public messages: Message[] = [];
}
